import { unconfirmedAccountIds, unconfirmedPositionsMessage, useTrading } from "@helm/core";

/**
 * Persistent warning while any account's positions are not confirmed by Rithmic (ADR-0032, launch
 * audit B2): HELM may then show the account FLAT while a real position is open. Driven by the
 * gateway's `POSITIONS_UNCONFIRMED` notice (and `PositionUpdate.mismatch`), cleared by
 * `POSITIONS_CONFIRMED`; a READY `Snapshot` replaces the set (audit AB-1: a client that starts
 * from a snapshot never saw the notices). Not dismissible. Desktop and mobile shells.
 */
export function UnconfirmedPositionsBanner(): React.JSX.Element | null {
  const positions = useTrading((s) => s.positions);
  const flags = useTrading((s) => s.unconfirmedAccounts);
  const ids = unconfirmedAccountIds({ positions, unconfirmedAccounts: flags });
  if (ids.length === 0) return null;
  return (
    <div className="banner banner-danger unconfirmed-banner" role="alert" data-testid="positions-unconfirmed">
      <strong>{unconfirmedPositionsMessage(ids)}</strong>
      {ids.map((id) => {
        const why = flags.get(id);
        return why ? (
          <span key={id} className="unconfirmed-why">
            {why}
          </span>
        ) : null;
      })}
    </div>
  );
}
